import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin, Card } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../../components/loader/loader';
import Transaction from './cards/transaction';
import JvInfo from './cards/info';
import Total from './cards/total';
import InvoiceJv from '../../../../components/journalVoucher/invoiceJv';

const JvForm = (props) => {

    const { api, userData, mainCurrency, accountData, wareHouseData, companyId, yearId, refData, } = useContext(DataContext);

    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const createdBy = parseInt(userData.id);


    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, getOpeningBalance } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [transactions, setTransactions] = useState([]);
    const [journalVoucher, setJournalVoucher] = useState({});


    const today = new Date().toISOString().split('T')[0];


    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const dataArray = ['auxAccount', 'currency', 'project', 'branch']
                await refData(dataArray, companyId);
                setIsLoading(false);
            } catch (error) {
                console.error('Error refreshing data Contact Support');
            }
        };
        if (showModal) {
            fetchData();
        }
    }, [showModal]);


    const resetForm = () => {
        setTransactions([transactionsItem]);
    }


    const debit = transactions.reduce((sum, item) => sum + parseFloat(item.debit), 0);
    const credit = transactions.reduce((sum, item) => sum + parseFloat(item.credit), 0);

    const totalDebit = transactions.reduce((sum, item) => sum + parseFloat(item.totalDebit), 0);
    const totalCredit = transactions.reduce((sum, item) => sum + parseFloat(item.totalCredit), 0);

    const secondaryTotalDebit = transactions.reduce((sum, item) => sum + parseFloat(item.secondaryTotalDebit), 0);
    const secondaryTotalCredit = transactions.reduce((sum, item) => sum + parseFloat(item.secondaryTotalCredit), 0);


    const transactionsItem = {
        accountId: null,
        currencyId: '',
        details: '',
        debit: 0,
        credit: 0,
        totalDebit: 0,
        totalCredit: 0,
        rate: 0,
    };


    // idRow Change
    useEffect(() => {
        setTransactions(idRow?.transactions || [transactionsItem])

        setJournalVoucher(
            {
                createdBy: createdBy,
                companyId: companyId,
                yearId: yearId,
                refNumber: idRow?.refNumber || '',
                date: idRow?.date || today,
                paymentType: 'cash',
                type: 'OpeningBalance',
                isOpeningBalance: true,
                totalDebit: idRow?.totalDebit || 0,
                totalCredit: idRow?.totalCredit || 0,
                secondaryTotalDebit: idRow?.totalDebit || 0,
                secondaryTotalCredit: idRow?.totalCredit || 0,
                details: idRow?.details || '',
                currencyId: idRow?.currencyId || mainCurrency?.id,

                projectId: idRow?.projectId || userRole.projectId,
                branchId: idRow?.branchId || userRole.branchId,
            }
        )
    }, [idRow]);


    useEffect(() => {

        setJournalVoucher(prevState => ({
            ...prevState,
            debit,
            credit,
            totalDebit,
            totalCredit,
            secondaryTotalDebit,
            secondaryTotalCredit,
        }));
    }, [debit, credit]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }

        if (transactions.length < 2) {
            toast.error('you need at least 2 transactions')
            return;
        }

        if (totalDebit - totalCredit !== 0) {
            toast.error('debit and credit must be equal')
            return;
        }


        setLoadingEffect(true);


        const data = {
            transactions,
            journalVoucher,
            jvId: idRow?.id,
        }
        const operation = idRow ? 'editOpeningBalance' : 'addOpeningBalance'
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                getOpeningBalance();
                toast.success(res.data.message);
                form.reset();
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }


    const closeModal = () => {
        toggleModal();
        if (refreshTable) { refreshTable() };
        if (resetForm) { resetForm() };
        setValidated(false);
    }



    return (
        <Modal show={showModal} fullscreen={true} onHide={toggleModal}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
            <Modal.Header closeButton>
                <Modal.Title >Opening Balance</Modal.Title>
            </Modal.Header>


            <Modal.Body style={{ backgroundColor: '#f0f2f5' }}>
                <Form validated={validated} id={'form'} onSubmit={handleSubmit}>

                    {isLoading &&
                        <Loader />
                    }

                    {!isLoading &&
                        <div>
                            <Row className="mb-3" >
                                <Col>
                                    <Card title="Journal Voucher" bordered={false}>
                                        <Transaction
                                            setTransactions={setTransactions}
                                            transactions={transactions}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Card title="Details" bordered={false}>
                                        <JvInfo
                                            setJournalVoucher={setJournalVoucher}
                                            journalVoucher={journalVoucher}
                                        />
                                    </Card>
                                </Col>
                                <Col>
                                    <Card title="Total" bordered={false}>
                                        <Total
                                            totalDebit={totalDebit}
                                            totalCredit={totalCredit}
                                            secondaryTotalDebit={secondaryTotalDebit}
                                            secondaryTotalCredit={secondaryTotalCredit}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                        </div>

                    }


                    <div style={{ textAlign: 'right' }}>
                        <Button type="primary" loading={loadingEffect} htmlType="submit"
                            onClick={() => setValidated(true)}
                            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
                    </div>
                </Form>
            </Modal.Body>



        </Modal>
    )
}


export default JvForm;